import React, { forwardRef } from 'react';

import MUITableSortLabel, {
  TableSortLabelProps as MUITableSortLabelProps,
} from '@material-ui/core/TableSortLabel';

export interface TableSortLabelProps extends MUITableSortLabelProps {}

const TableSortLabel = forwardRef<HTMLSpanElement, TableSortLabelProps>(
  (props, ref) => {
    return <MUITableSortLabel {...props} ref={ref} />;
  }
);

export default TableSortLabel;
